export default __webpack_public_path__ + "static/media/instagram.44384132.png";